const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 566.933,
    width: 566.933,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53c5bf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M3140.4 2125.99c0-560.25-454.17-1014.42-1014.41-1014.42-560.25 0-1014.42 454.17-1014.42 1014.42 0 560.24 454.17 1014.41 1014.42 1014.41 560.24 0 1014.41-454.17 1014.41-1014.41",
    transform: "matrix(.13333 0 0 -.13333 0 566.933)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M1231.61 2099.86c0 189.51 112.5 321.86 290.58 321.86 179.28 0 291.18-133.56 291.18-321.86 0-190.12-113.1-321.87-290.58-321.87-178.68 0-291.18 133.56-291.18 321.87zm437.98 0c0 116.11-54.15 202.14-147.4 202.14-94.46 0-146.8-89.04-146.8-202.14 0-114.31 52.34-202.15 146.8-202.15 95.05 0 147.4 86.64 147.4 202.15",
    transform: "matrix(.13333 0 0 -.13333 0 566.933)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b4ca8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M1854.16 2398.36h130.69v-108.8l-6.91 6.32c33.96 78.3 96.71 117.45 176.74 117.45 142.77 0 237.18-127.81 237.18-306.27 0-189.99-105.92-309.73-240.07-309.73-82.32 0-140.46 46.64-170.4 103.63l8.63 9.79v-316.64h-135.86zm423.35-290.73c0 116.3-71.02 191.13-154.5 191.13-84.05 0-132.99-76.57-132.99-188.25v-8.06c0-111.69 50.67-190.55 132.99-190.55 83.48 0 154.5 78.29 154.5 195.73m547.56-194.6 8.06-8.64c-29.94-64.47-91.54-107.08-174.44-107.08-139.89 0-235.46 127.81-235.46 308.01 0 184.22 100.75 307.99 242.37 307.99 85.78 0 141.62-46.05 169.26-113.42l-4.61-9.78v108.23h130.11V1594.1h-135.29zm0 185.38v8.05c0 113.42-49.51 192.28-132.99 192.28-84.05 0-155.07-77.14-155.07-192.28 0-115.13 71.59-194.58 155.07-194.58 82.32 0 132.99 77.14 132.99 186.53",
    transform: "matrix(.13333 0 0 -.13333 0 566.933)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.23809b9a2d1537a1f8d656cf06025a47.svg";
export { ForwardRef as ReactComponent };